import i18next from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend from 'i18next-http-backend';
import {
  initReactI18next,
  useTranslation as useTranslationI18next,
} from 'react-i18next';

// TODO
const TRANSLATION_NAMESPACES = ['infolayer', 'favourites', 'filter'];

export function initTranslations(
  translationLanguages = ['en', 'de', 'nl', 'fr'],
  translationPath,
) {
  return i18next
    .use(I18nextBrowserLanguageDetector)
    .use(I18NextHttpBackend)
    .use(initReactI18next)
    .init({
      ns: TRANSLATION_NAMESPACES,
      //   defaultNs: TRANSLATION_DEFAULT_NS,
      supportedLngs: translationLanguages,
      nonExplicitSupportedLngs: true,
      load: 'languageOnly',
      cleanCode: true,
      backend: {
        loadPath: translationPath,
      },
    });
}

export function useTranslation(ns, options = {}) {
  const translationFunctions = useTranslationI18next(ns, options);
  return translationFunctions.t;
}
